export const api = {
  GET_INSPECTION_OTHER_DETAILS: '/inspections/getOtherInspectionByID',
  SUBMIT_INSPECTION_OTHER: '/inspections/submitOtherInspection',
};
